module.exports = __webpack_public_path__ + "img/truck-tow.f50e36a7.svg";